import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/plugins/i18n";
import { LControl, LGeoJson, LMap, LMarker, LPopup, LTileLayer, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import "@mdi/font/css/materialdesignicons.css";
import CountryFlag from "vue-country-flag";
import GlobalEvents from "vue-global-events";
import "typeface-roboto/index.css";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import utils from "@/utils";

Vue.use(Vuetify);

// map
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-tooltip", LTooltip);
Vue.component("l-control", LControl);
Vue.component("l-geo-json", LGeoJson);

// flags
Vue.component("country-flag", CountryFlag);

// global events
Vue.component("global-events", GlobalEvents);

// validation
Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend("decimal", {
  validate: (value, { decimals, separator }) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false
      };
    }

    if (decimals === undefined)
      decimals = "*";

    if (separator === undefined)
      separator = i18n.t("lang.decimal_separator");

    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value)
      };
    }
    const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value)
    };
  },
  params: [
    {
      name: "decimals",
      cast(value) {
        return Number(value);
      }
    }
  ]
});

extend("sensor_nvalues", {
  validate: (value) => {
    try {
      utils.stringToNValues(value);
      return true;
    } catch (error) {
      return false;
    }
  }
});

extend("period", {
  validate: (value) => {
    try {
      const periodPattern = /^(\d+r)?\s*(\d+m)?\s*(\d+d)?$/;
      return periodPattern.test(value.trim());
    } catch (error) {
      return false;
    }
  }
});

extend('phone', {
  validate: value => {
    // Regexp pro validaci telefonních čísel
    const phoneRegex = /^\+?[1-9]\d{0,2}[\s.-]?\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/;
    return phoneRegex.test(value);
  },
  message: 'Telefonní číslo musí mít správný formát.'
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        //primary: '#aac800',
      },
      dark: {
        //primary: '#aac800',
        //background: colors.indigo.base,
      }
    }
  },
  icons: {
    iconfont: "mdi"
  },
  lang: {
    current: "cs",
    t: (key, ...params) => i18n.t(key, params)
  }
});